export default __webpack_public_path__ + "d61ba8bed6bbebaa5be4542589d80fcb.svg";